import React from "react";
import { ReaderItem } from "../../../models/reader";
import ReadersRow from "./row";

type RenderComingSoonPrps = {
  readers: ReaderItem[];
  rowNum: number;
  arrowNav: (y_val: number, x_val: number, direction: "left" | "right") => void;
};
const RenderComingSoon: React.FC<RenderComingSoonPrps> = ({
  readers,
  rowNum,
  arrowNav,
}) => {
  const coming_soon_readers = readers.filter((reader) => reader.coming_soon);
  if (coming_soon_readers.length < 1) return null;
  return (
    <ReadersRow
      arrowNav={arrowNav}
      is_trending={false}
      is_continue_reading={true}
      is_first={true}
      rowNum={rowNum}
      totalRows={rowNum}
      activeReader={false}
      title="Coming Soon"
      cat_id="coming_soon"
      readers={coming_soon_readers}
      isActive={false}
    />
  );
};

export default RenderComingSoon;
